import React, { useEffect, useState } from "react";
import {
  Container,
  Box,
  TextField,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const UpdateProfile = () => {
  const navigate = useNavigate();

  // State Management
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // Fetch user details (replace with actual API call)
  const getUserDetails = () => {
    setIsLoading(true);
    // Simulate API call delay
    setTimeout(() => {
      const user = {
        name: "John Doe",
        email: "john.doe@example.com",
        phoneNumber: "+1234567890",
      };
      setName(user.name);
      setEmail(user.email);
      setPhoneNumber(user.phoneNumber);
      setIsLoading(false);
    }, 1000);
  };

  useEffect(() => {
    getUserDetails();
  }, []);

  const handleUpdate = () => {
    if (!name) {
      alert("Name cannot be empty");
      return;
    }
    setIsLoading(true);

    // Simulate API update call
    setTimeout(() => {
      setIsLoading(false);
      alert("Profile updated successfully!");
      navigate("/profile"); // Redirect to profile page
    }, 1000);
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ textAlign: "center", mt: 5 }}>
        <Typography variant="h4">Update Profile</Typography>
      </Box>

      {isLoading ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
          <CircularProgress />
        </Box>
      ) : (
        <Box sx={{ mt: 3 }}>
          <TextField
            fullWidth
            label="Full Name"
            variant="outlined"
            value={name}
            onChange={(e) => setName(e.target.value)}
            sx={{ mb: 2 }}
          />

          <TextField
            fullWidth
            label="Email"
            variant="outlined"
            value={email}
            disabled
            sx={{ mb: 2 }}
          />

          <TextField
            fullWidth
            label="Phone Number"
            variant="outlined"
            value={phoneNumber}
            disabled
            sx={{ mb: 2 }}
          />

          <Button
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 2 }}
            onClick={handleUpdate}
          >
            Update
          </Button>

          <Button
            variant="outlined"
            fullWidth
            sx={{ mt: 2 }}
            onClick={() => navigate("/profile")}
          >
            Cancel
          </Button>
        </Box>
      )}
    </Container>
  );
};

export default UpdateProfile;
